<script lang="ts" setup>
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useForm } from '@inertiajs/vue3'
import { inject } from 'vue'

const form = useForm({
    coupon_code: '',
})

const { sessionCart } = inject<{
    sessionCart?: string
}>('stepControl', {
    sessionCart: '',
})
</script>

<template>
    <Card>
        <Accordion collapsible>
            <AccordionItem value="1">
                <AccordionTrigger class="text-lg font-medium">
                    {{ $t('Do you have a discount coupon?') }}
                </AccordionTrigger>
                <AccordionContent>
                    <form
                        @submit.prevent="
                            sessionCart
                                ? form.get('/session_cart/require_login')
                                : form.post('/cart/apply_coupon', {
                                      onSuccess: () => {
                                          form.reset()
                                      },
                                  })
                        "
                        class="flex items-end gap-6 p-4"
                    >
                        <div class="grid items-center gap-2 sm:w-4/12">
                            <Label for="coupon" class="text-base font-medium">{{ $t('Apply Coupon') }}</Label>
                            <Input id="coupon" v-model="form.coupon_code" type="text" :placeholder="$t('Enter a valid coupon')" class="h-[48px]" />
                        </div>
                        <Button :disabled="form.processing" class="h-[48px] text-sm">{{ $t('Apply') }}</Button>
                    </form>
                </AccordionContent>
            </AccordionItem>
        </Accordion>
    </Card>
</template>
